<template>
  <div class="w-full flex flex-col space-y-1">
    <div class="flex space-x-4">
      <div v-for="(item, index) in items" :key="item.value">
        <Field v-slot="{ field }" :id="name + index" :name="name" type="radio">
          <RadioButton
            v-bind="field"
            :modelValue="value"
            :inputId="name + index"
            :name="name"
            :value="item.value"
            :disabled="disabled"
          />
        </Field>
        <label :for="name + index" class="ml-2 cursor-pointer">{{ item.label }}</label>
      </div>
    </div>
    <ErrorMessage class="text-red-600" :name="name" />
  </div>
</template>

<script setup lang="ts">
import { Field, ErrorMessage, useFieldValue } from 'vee-validate'
import RadioButton from 'primevue/radiobutton'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  items: {
    type: Array<{
      label: string
      value: string
      checked?: boolean
    }>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const value = useFieldValue(props.name)
</script>
